import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuex from 'vuex'
import "swiper/swiper.min.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import SvgArrow from '@/components/svg-arrow.vue'
Vue.component('SvgArrow', SvgArrow)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vuex)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
